import styled from 'styled-components';
import { getFontSize } from '../../../../utils/getFont';

export const Content = styled.div`
  text-align: center;
  padding: 2rem;
  position: relative;
  margin-top: 150px;
  cursor: default;

  > h2 {
    font-family: var(--text-cursive2);
    ${getFontSize(10)}
    margin-bottom: 80px;
  }

  .rama2 {
    position: absolute;
    left: 0;
    top: -25px;
    height: 80px;
    width: auto;
    rotate: 150deg;
  }

  .rama1 {
    position: absolute;
    right: 0;
    top: 90px;
    height: 80px;
    width: auto;
    rotate: 180deg;
  }

  @media (max-width: 493px) {
    .rama1 {
      top: 140px;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;

    h4 {
      ${getFontSize(4)}
      margin: 10px 0;
    }

    p {
      font-family: var(--text-normal);
      ${getFontSize(3)}
      margin: 1rem 0;
    }
  }
`;
